import React, { useContext, useEffect, useState } from 'react'
import {
  Box,
  Button,
  FormLabel,
  Tab,
  Tabs,
  TextField,
  Typography
} from '@mui/material'
import PropTypes from 'prop-types'

import TabPanel from '../../../../../common/TabPanel/TabPanel.jsx'
import { ColorBoxContent } from '../../../../../common/ui/colorBox'
import JoyrideContext from '../../../../../context/joyride/joyrideContext.js'
import { OnboardingPlan } from '../../../../Onboarding/components/OnboardingPlan.jsx'

/** @type {Object.<string, import('@mui/styled-engine').CSSProperties>} */
const classes = {
  '& .MuiTab-root': {
    textTransform: 'initial',
    fontWeight: '600',
    fontSize: '16px',
    color: 'black',
    borderRadius: '20px',
    textDecoration: 'none'
  },
  '& .MuiTab-root.Mui-selected': {
    borderBottomStyle: 'none',
    backgroundColor: 'blue',
    color: 'white'
  },
  '& .MuiTab-root.Mui-selected:first-of-type': {
    borderRadius: '20px'
  }
}

function PlanOptions(props) {
  const {
    planId,
    setPlanId,
    plans,
    product,
    numberOfSims,
    setNumberOfSims,
    goNextPage
  } = props
  const joyrideContext = useContext(JoyrideContext)
  const { tourActive, setRun } = joyrideContext

  const [simError, setSimError] = useState('')

  /* No. of sims have to be minimum 1 and maximum 100 */

  const maxSims = 1000 // Max number of sims to be ordered

  const handleSimChange = (quantity) => {
    quantity = Number(quantity)
    if (quantity > maxSims) {
      setNumberOfSims(null)
      setSimError(`The maximum no. of SIMs per order is ${maxSims}`)
    } else if (quantity < 0) {
      setNumberOfSims(null)
      setSimError('Please enter a positive number.')
    } else if (
      quantity === '' ||
      quantity === 0 ||
      !Number.isInteger(quantity)
    ) {
      setNumberOfSims(null)
      setSimError('Please enter a valid number.')
    } else {
      setSimError('')
      setNumberOfSims(quantity)
    }
  }

  /* Reorder plans */
  const sortPlans = (a, b) => {
    if (a.price < b.price) {
      return -1
    }
    if (a.price > b.price) {
      return 1
    }
    return 0
  }

  plans.sort(sortPlans)
  const filtered = plans.filter(i => i._id !== '').map(i => {
    if (product.includes(i._id)) i.display = 'block'
    else i.display = 'none'
    return i
  })

  const handleTabChange = (_, val) => {
    setPlanId(val)
  }
  const handleSelectPlanNextClick = (id) => {
    setPlanId(id)
    goNextPage()
  }
  useEffect(() => {
    if (tourActive) {
      setTimeout(() => {
        setRun(true)
      }, 500)
    }
  }, [])

  return (
    <Box sx={{ padding: '0px 16px' }}>
      <Typography variant='h4'>Preorder Your Plan</Typography>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'space-between',
          marginBottom: '16px'
        }}
      >
        <Typography>
          Select the plans intended for your business needs.
        </Typography>
      </Box>
      <Box>
        <Tabs
          sx={classes}
          value={planId}
          onChange={handleTabChange}
          TabIndicatorProps={{
            style: { display: 'none' }
          }}
        >
          {filtered.map((plan, id) => (
            <Tab
              sx={{
                p: '10px 40px',
                display: plan?.display
              }}
              label={`${plan.productName ? plan.productName : ''}`}
              value={id}
              key={`plan-${id}`}
            />
          ))}
        </Tabs>
      </Box>

      {filtered.map((plan, id) => (
        <TabPanel
          key={plan._id}
          name={plan.productName}
          value={id}
          index={planId}
        >
          <Box
            sx={{
              display: 'flex',
              width: '100%',
              m: '32px 0px',
              alignItems: 'center'
            }}
          >
            <OnboardingPlan key={plan._id} plan={plan} />
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
                width: '100%',
                marginLeft: '40px'
              }}
            >
              <div
                id='buyNewSim__input'
                data-cy='numSims'
                style={{ marginBottom: 16 }}
              >
                <FormLabel> No. of SIMs</FormLabel>
                <TextField
                  variant='standard'
                  fullWidth
                  label=''
                  type='number'
                  value={numberOfSims}
                  onChange={(e) => handleSimChange(e.target.value)}
                  error={simError}
                />
              </div>
              <ColorBoxContent
                variant='secondary'
                style={{
                  border: '2px solid #0000FF',
                  borderRadius: '8px',
                  padding: '8px 0'
                }}
              >
                <Box
                  sx={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    borderBottom: `2px solid #0000FF`,
                    padding: `4px 16px`
                  }}
                >
                  <Typography variant='h5'>Order Summary</Typography>
                </Box>

                <Box
                  sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    padding: '16px'
                  }}
                >
                  <Box
                    sx={{
                      display: 'flex',
                      flexDirection: 'row',
                      justifyContent: 'space-between'
                    }}
                  >
                    <Typography sx={{ color: '#818D9C' }}>
                      <b>No. of SIMs</b>
                    </Typography>
                    <div id='numOfSimOrderSummary' data-cy='numSims'>
                      <Typography>
                        <b>{numberOfSims} SIMs</b>
                      </Typography>
                    </div>
                  </Box>
                  <Box
                    sx={{
                      display: 'flex',
                      flexDirection: 'row',
                      justifyContent: 'space-between'
                    }}
                  >
                    <Typography sx={{ color: '#818D9C' }}>
                      <b>Total Fees</b>
                    </Typography>
                    <Box
                      sx={{
                        display: 'flex',
                        alignItems: 'baseline'
                      }}
                    >
                      <Typography variant='h4'>
                        <b>
                          $
                          {(plan.baseplan.price.value * numberOfSims).toFixed(
                            2
                          )}
                        </b>
                      </Typography>
                      <Typography sx={{ color: '#818D9C' }}>
                        <b>/mo.</b>
                      </Typography>
                    </Box>
                  </Box>
                </Box>
              </ColorBoxContent>
            </Box>
          </Box>
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'flex-end',
              alignItems: 'center'
            }}
          >
            <div id='buyNewSim__nextBtn'>
              <Button
                id='nextButton'
                aria-label='next page'
                variant='filled'
                disabled={Boolean(simError)}
                onClick={() => handleSelectPlanNextClick(id)}
                data-cy='planNextBtn'
              >
                Next
              </Button>
            </div>
          </Box>
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center'
            }}
          >
            Can&apos;t find a suitable plan? You can reach out to our team to
            enquire for more details&nbsp;
            <a
              href='https://forms.gle/2R6B3dqAFr6i6yLx5'
              rel='noreferrer'
              target='_blank'
            >
              {' '}
              here{' '}
            </a>
            .
          </Box>
        </TabPanel>
      ))}
    </Box>
  )
}

PlanOptions.propTypes = {
  planId: PropTypes.number.isRequired,
  setPlanId: PropTypes.func.isRequired,
  plans: PropTypes.array.isRequired,
  product: PropTypes.array.isRequired,
  numberOfSims: PropTypes.number.isRequired,
  setNumberOfSims: PropTypes.func.isRequired,
  goNextPage: PropTypes.func.isRequired
}

export default PlanOptions
